/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

// the library resource from core for use with kits or sets
import { library } from "@fortawesome/fontawesome-svg-core";

// named "selected" icons in the kit organized by prefix/family
import { all } from "./simplicity/all";
import { brands } from "./simplicity/brands";
import { solid as solidKit } from "./simplicity/solid";
import { regular as regularKit } from "./simplicity/regular";

// We import one entire font set to support using dynamic font names
// all regular pro icons ! 2.5Mb !
const AVAILABLE_PREFIXES = ["far"];
import * as farIcons from "@fortawesome/pro-regular-svg-icons";
// import * as fasIcons from '@fortawesome/pro-solid-svg-icons'
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { isStringNotEmpty } from "utils/empty-exists";
const regular = { ...far, ...regularKit };
const solid = { ...fas, ...solidKit };
library.add(far, fas, ...all);
const getIcon = (prefix, name) => {
    if (!prefix) {
        prefix = "far";
    }
    if (isStringNotEmpty(name) || name === null) {
        return null;
    }
    // const icon = byPrefixAndName[prefix][name]
    const icon = farIcons[name];
    // const icon = fasIcons[name]
    return icon?.icon;
};

export {
    AVAILABLE_PREFIXES,
    regular,
    solid,
    brands,
    all,
    getIcon,
};
